import React, {useState, createContext} from 'react'
import "../styles/container.scss"
import ScritteOblique from "../components/ScritteOblique"
import EnnesimaAgenzia from './EnnesimaAgenzia'
import "../styles/Elementi.scss";
import CerchiCasa from './CerchiCasa'
import HaiImmobile from './HaiImmobile'
import FormContatto from './FormContatto'
import RiquadroVerdeManifesto from './RiquadroVerdeManifesto'
import ChiSiamo from './ChiSiamo'
import Manifesto from './Manifesto'


export default function Container() {

    return (
                <div className='page_contents bianco'>
                    <ScritteOblique />
                    <div className='page_sections'>
                        <EnnesimaAgenzia />
                        <CerchiCasa />
                        <HaiImmobile />

                        <FormContatto />

                        <RiquadroVerdeManifesto />
                        {/*<ChiSiamo />*/}

                        {/*<Manifesto />*/}

                    </div>
                </div>
  )
}

